import { Button } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';

import { finleyAssert } from '@finley-technologies/common';
import {
  DataPipeline,
  LimitedPartners,
} from '@finley-technologies/finley-types';

import { CustomError } from 'packages/dataPipeline/types/dataPipelineTypes';

/**
 * returns a custom error message if the pipeline incurred error about limited partner alias matching
 */
export const getCustomError = ({
  instances,
}: {
  artifacts: DataPipeline.Artifact[];
  instances: DataPipeline.Instance[];
}): CustomError | null => {
  // we want to render a custom error message
  // if all the errors were in 'limitedPartnersTape' node
  // and if they all were of specific type.
  const errorInstances = instances.filter(
    (instance) => instance.status === 'error',
  );
  if (errorInstances.length !== 1) {
    // we only show a custom message about limited partners aliases
    // if there was a single instance in error state
    return null;
  }
  const errorInstance = errorInstances[0];

  // we already filtered for the error above
  // this assert just helps TS narrow down the type
  finleyAssert(
    errorInstance.status === 'error',
    `getCustomErrorMessage:instance status is not error [artifactId:${errorInstance.artifactId}]`,
  );

  if (errorInstance.statusDetails.errors.length !== 1) {
    // we can only handle single error.
    return null;
  }

  const errorDetails = errorInstance.statusDetails.errors[0];

  if (
    errorDetails.content.internalProperties?.type !==
    LimitedPartners.LimitedPartnerNotFoundError
  ) {
    // this is not the error we can handle.
    return null;
  }

  const actionElement = (
    <Button
      as={Link}
      to="/limited-partners/alias-matching"
      variant="link"
      colorScheme="blue"
    >
      Match LP Aliases
    </Button>
  );

  return {
    customMessage: errorDetails.content.externalMessage,
    actionElement,
  };
};
